<template>
  <div id="app" class="home">
    <img
      class="home__logo"
      alt="Kapita vins logo"
      src="./assets/logo-kapita-vins.png"
      data-aos="fade-down"
      data-aos-delay="100"
      data-aos-duration="1500"
      data-aos-easing="ease-in-out"
    />
    <h1
      class="home__title"
      data-aos="zoom"
      data-aos-delay="100"
      data-aos-duration="2500"
      data-aos-easing="ease-in-out"
    >
      Création et développement de marques de vin
    </h1>
    <div
      class="home__contact"
      data-aos="fade-up"
      data-aos-delay="100"
      data-aos-duration="1500"
      data-aos-easing="ease-in-out"
    >
      <h2 class="home__contact_title">contact</h2>
      <a class="home__contact_mail" href="mailto:nans@kapita-vins.com"
        >nans@kapita-vins.com</a
      >
      <p>+33 6 70 00 21 31</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300&display=swap");
@font-face {
  font-family: "Source Sans Variable";
  src: local("Source Sans Variable"),
    url(./fonts/SourceSans3-Light.ttf) format("truetype");
}
$font: "Source Sans Variable";
$color: #0c0c0c;
html,
body {
  scroll-behavior: smooth;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-repeat: no-repeat;
  font-size: 12px;
  width: 100%;
  font-family: $font, sans-serif;
  * {
    box-sizing: border-box;
  }
}
.home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__logo {
    width: 70%;
    @media (max-width: 768px) {
      width: 85%;
    }
  }
  &__title {
    font-family: $font, sans-serif;
    font-size: 41px;
    font-weight: 300;
    @media (max-width: 768px) {
      font-size: 31px;
      width: 90%;
    }
  }
  &__contact {
    font-family: $font, sans-serif;
    font-size: 24px;
    font-weight: 300;
    @media (max-width: 768px) {
      font-size: 18px;
    }

    &_title {
      font-family: "Helvetica";
      font-weight: 100;
      font-size: 37px;
      text-transform: uppercase;
      margin-top: 50px;
      margin-bottom: 10px;
      @media (max-width: 768px) {
        font-size: 27px;
      }
    }
    &_mail {
      outline: none;
      text-decoration: none;
      color: $color;
      &::after {
        content: "";
        width: 0%;
        height: 1px;
        display: block;
        background: $color;
        transition: width 0.3s ease;
      }
      &:hover::after {
        width: 100%;
      }
    }
  }
  p {
    margin: 0;
  }
}
</style>
